module.exports = __webpack_public_path__ + "img/warning.58c75757.png";